import Header from "@/types/app/header";

export default class CustomerNotification {
  public static header: Header[] = [
    {
      text: "Send date",
      align: "start",
      sortable: true,
      value: "dtNotification",
      class: "item-table-header item-table-header-date",
      width: ""
    },    
    {
      text: "Title",
      align: "start",
      sortable: true,
      value: "title",
      class: "item-table-header item-table-header-amount",
      width: ""
    },
    {
      text: "Message",
      align: "start",
      sortable: true,
      value: "description",
      class: "item-table-header item-table-header-description",
      width: ""
    },    
    {
      text: "Link To App",
      align: "start",
      sortable: true,
      value: "hasAppUrl",
      class: "item-table-header item-table-header-hasAppUrl",
      width: ""
    },
    {
      text: "Author",
      align: "start",      
      sortable: true,
      value: "authorName",
      class: "item-table-header item-table-header-authorName",
      width: ""
    },
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
